import './App.css'
import axios from "axios"
import {EnrollmentPage} from "./sections/enrollment/enrollment.page"
import {NewEnrollmentsPage} from "./sections/enrollment/new-enrollments.page"
import {EnrollmentPaymentPage} from "./sections/enrollment/enrollment-payment.page"
import {EnrollmentPaymentConfirmPage} from "./sections/enrollment/enrollment-payment-confirm.page"
import {EnrollmentsGuard} from "./sections/enrollment/EnrollmentsGuard"
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from 'react-router-dom'
import RootLayoutPage from './sections/root-layout/root-layout.page'
import ErrorPage from './sections/error/error.page'
import HomePage from './sections/home/home.page'
import ResetPasswordPage from "./sections/admin/reset-password/reset-password.page"
import LoginGuardPage from "./sections/login-guard/login-guard.page"
import ResetPasswordRequestPage from './sections/admin/reset-password-request/reset-password-request.page'
import PrivateRoute from './common/PrivateRoute'
import ChangePasswordPage from './sections/change-password/change-password.page'
import EditSchoolPage from './sections/school/edit-school.page'
import EditSchoolInfoPage from "./sections/user/edit-user.page"
import ActiveEventRoute from "./common/ActiveEventRoute"
import CompleteSchoolDataGuard from './sections/subscriptions/new/CompleteSchoolDataGuard'
import NewSubscriptionPage from './sections/subscriptions/new/new-subscription.page'
import CompetitorsPage from './sections/competitor/competitors.page'
import DashboardPage from './sections/admin/dashbord/dashboard.page.'
import LoginPage from "./sections/admin/login/login.page"
import {PaymentRoute} from "./common/PaymentRoute"
import NotificationComponent from "./common/notification.component"
import SubscriptionsPage from "./sections/subscriptions/list/subscriptions.page"
import PrivateAdminRoute from "./common/PrivateAdminRoute"
import {EventDetailPage} from "./sections/event-detail/event-detail.page";

const App = () => {
    axios.defaults.withCredentials = true

    const router = createBrowserRouter(createRoutesFromElements(
        <>
            <Route path='/' element={<RootLayoutPage/>} errorElement={<ErrorPage/>}>
                <Route path="/" element={<HomePage/>}/>
                <Route path="home" element={<HomePage/>}/>
                <Route path="login" element={<LoginGuardPage/>}/>
                <Route path="reset-password-request" element={<ResetPasswordRequestPage/>}/>
                <Route path="reset-password" element={<ResetPasswordPage/>}/>
                <Route element={<PrivateRoute/>}>
                    <Route path="change-password" element={<ChangePasswordPage/>}/>
                    <Route path="school" element={<EditSchoolPage/>}/>
                    <Route path="school-info" element={<EditSchoolInfoPage/>}/>
                    <Route path="event/:eventId">
                        <Route index={true} element={<EventDetailPage/>}/>
                        <Route element={<ActiveEventRoute/>}>
                            <Route path="new-subscription" element={
                                <CompleteSchoolDataGuard>
                                    <NewSubscriptionPage/>
                                </CompleteSchoolDataGuard>
                            }/>
                        </Route>
                    </Route>
                    <Route path="subscriptions" element={<SubscriptionsPage/>}/>
                    <Route path="competitors" element={<CompetitorsPage/>}/>
                </Route>
                <Route path="admin/1a9e8dde1c3e769701aa1feb80754b43ae6eb2e48a952f663f3452b2ad19430c">
                    <Route element={<PrivateAdminRoute></PrivateAdminRoute>}>
                        <Route index={true} element={<DashboardPage/>}/>
                        <Route path="dashboard" element={<DashboardPage/>}/>
                    </Route>
                    <Route path="login" element={<LoginPage/>}/>
                </Route>
            </Route>
            <Route path='/' element={<RootLayoutPage/>} errorElement={<ErrorPage/>}>
                <Route element={<PrivateRoute/>}>
                    <Route element={<EnrollmentsGuard/>}>
                        <Route path="enrollments">
                            <Route index={true} element={<EnrollmentPage/>}/>
                            <Route path="new" element={<NewEnrollmentsPage/>}/>
                            <Route path="payment">
                                <Route element={<PaymentRoute/>}>
                                    <Route index={true} element={<EnrollmentPaymentPage/>}/>
                                </Route>
                                <Route path="confirm" element={<EnrollmentPaymentConfirmPage/>}/>
                            </Route>
                        </Route>
                    </Route>
                </Route>
            </Route>
        </>
    ))

    return (
        <>
            <NotificationComponent/>
            <RouterProvider router={router}/>
        </>

    )
}

export default App